import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.scrolling = false
    this.activeScroller = null
    this.handleScroll = this.handleScroll.bind(this)

    window.addEventListener("scroll", this.handleScroll)
    document.addEventListener("scroll", this.handleScroll, true)

    this.updateButton(false)
  }

  handleScroll(event) {
    if (this.scrolling) return

    const element = event.target === document ? window : event.target

    let scrollTop
    if (element === window) {
      scrollTop = window.scrollY
    } else {
      scrollTop = element.scrollTop
    }

    this.activeScroller = element
    this.updateButton(scrollTop > 200)
  }

  updateButton(show) {
    this.buttonTarget.hidden = !show
  }

  scrollToTop(event) {
    event.preventDefault()
    this.scrolling = true
    this.updateButton(false)

    let target = this.activeScroller

    if (!target || target === window || target === document) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    } else {
      target.scrollTo({ top: 0, behavior: "smooth" })
    }

    setTimeout(() => {
      this.scrolling = false
    }, 600)
  }
}
